import type { LineDiscount } from '@bms2/shared';

/**
 * 🔒 A draft line's discount as a save and the tax preview send it (decisions
 * 0097, 1031): the kind, and the figure in the unit the server stores, a
 * percentage or dollars. The Quote's form writes the same two fields inline.
 */
export function discountFieldsOf(discount: LineDiscount | null | undefined): { discountType: 'Percentage' | 'Flat' | null; discountValue: number | null } {
  if (!discount) return { discountType: null, discountValue: null };
  return discount.kind === 'Percentage' ? { discountType: 'Percentage', discountValue: discount.percent } : { discountType: 'Flat', discountValue: discount.amount.amount / 100 };
}

/** The Discount Scope an opening read names, Footer where it names none (decisions 0097, 1031). */
export function discountLevelOf(level: string | null | undefined): 'Line' | 'Footer' {
  return level === 'Line' ? 'Line' : 'Footer';
}
